import { render, staticRenderFns } from "./CeremonyForm.vue?vue&type=template&id=555223f6"
import script from "./CeremonyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CeremonyForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports